import { render, staticRenderFns } from "./DepartamentoAreaEditor.vue?vue&type=template&id=4ae091ec"
import script from "./DepartamentoAreaEditor.vue?vue&type=script&lang=js"
export * from "./DepartamentoAreaEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports